module.exports = __webpack_public_path__ + "static/media/CL 3.b38a6385.mp3";